<template>
  <div>
    <div
      :id="`action-panel-${text.toLowerCase()}`"
      :class="`icon-text-button ${customClass}`"
      :title="tooltip"
      @click="$emit('button:clicked')"
    >
      <component
        :is="button"
        v-if="kind == 'icon' || kind == 'ghost'"
        class="icon-size"
      />
      <img
        v-if="kind == 'lanyard'"
        :src="require('../../../../assets/lanyard-icon-trim.png')"
        :width="16"
        :height="32"
      />
      <span class="text">{{ text }}</span>
    </div>
  </div>
</template>
<script>
import { CvIconButton } from '@carbon/vue';
import Vue, { PropType } from 'vue';

export default {
  components: {
    CvIconButton,
  },
  props: {
    text: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    kind: {
      type: String,
      required: false,
      default: 'ghost',
    },
    button: {
      type: Object,
      required: true,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
.icon-text-flex-column {
  flex-direction: column;
}
.icon-text-flex-row {
  flex-direction: row;
}

.icon-size {
  width: 20px;
  height: 20px;
}

.text {
  margin-top: 3px;
}
.icon-text-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  flex-direction: column;
  width: 60px;
  height: 60px;

  &-icon {
    overflow: hidden !important;
    &:hover {
      background: #e0e0e0;
    }
  }

  &:hover {
    cursor: pointer;
    background: #e0e0e0;
  }
}
</style>
<style scoped>
.cv-button:hover {
  outline: none !important;
  background: #e0e0e0 !important;
  border: none !important;
}

.cv-button:focus {
  outline: none !important;
  background: #e0e0e0 !important;
  border: none !important;
}

.cv-button:active {
  outline: none !important;
  background: #e0e0e0 !important;
  border: none !important;
}
</style>
